import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RepositoryManagementState {
  typeFilter: string;
}

const initialState: RepositoryManagementState = {
  typeFilter: '-1',
};

const repositoryManagementSlice = createSlice({
  name: 'repositoryManagement',
  initialState,
  reducers: {
    setTypeFilter(state, action: PayloadAction<string>) {
      state.typeFilter = action.payload;
    },
  },
  selectors: {
    getTypeFilter: state => state.typeFilter,
  },
});

export const { setTypeFilter } = repositoryManagementSlice.actions;
export default repositoryManagementSlice;
